module.exports = __webpack_public_path__ + "static/media/Pirate600_1c.92aba2a9.svg";